<template>
<v-app>

<v-navigation-drawer
      v-model="drawer"
      app
      clipped
      color="#2f363e"
    >


      <v-list subheader>
                              <v-subheader>Juegos</v-subheader>
          <v-list-item >
              <v-list-item-action>
                  <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Juegos'}"><v-icon>fas fa-gamepad</v-icon></router-link>
              </v-list-item-action>
              <v-list-item-content>
                  <v-list-item-title><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'Juegos'}">Juegos</router-link></v-list-item-title>
              </v-list-item-content>
          </v-list-item>


          <v-list-item >
              <v-list-item-action>
                <router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'JuegosInscritos'}"> <v-icon>fas fa-smile</v-icon></router-link>
              </v-list-item-action>
              <v-list-item-content>
                  <v-list-item-title><router-link color="white" style="text-decoration:none;color:white;font-size:12px;" :to="{ name: 'JuegosInscritos'}">{{ $t('menu.inscritos') }}</router-link></v-list-item-title>
              </v-list-item-content>
          </v-list-item>

      </v-list>
    </v-navigation-drawer>
  <v-app-bar
      app
      clipped-left
      color="#2f363e"
  >
    <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <v-toolbar-title>
      <router-link :to="{ name: 'homepage'}">

      <v-img
        alt="Tunay Logo"
        class="shrink mt-1 "
        contain
        min-width="100"
        src="@/assets/tunaywhitelogo.png"
        width="100"
    />
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
   <!-- <v-btn
        v-for="link in links"
        :key="link.url"
        color="white"
        text
        :href="link.href"
        rounded
        class="my-2 hidden-sm-only hidden-xs-only"
    >
      {{ link.url }}
    </v-btn> -->

    <loginbox :paises="paises" :browser="browser" :abreviado="abreviado" :ttnegocios="ttnegocios"  :tpromotor="tpromotor" :tsuperadmin="tsuperadmin" :tsocio="tsocio" />
  </v-app-bar>
</v-app>
</template>
<script>
import { mapGetters } from "vuex";
import loginbox from '../modals/loginbox';
import axios from "axios";
import store from "@/store";
import tipoentrjson from "@/assets/json/tipoentradas.json";
import tipopagjson from "@/assets/json/tipopagos.json";
import tipoevenjson from "@/assets/json/tipoeventos.json";
import tipomembrjson from "@/assets/json/tipomembresias.json";
import sexosjson from "@/assets/json/sexos.json";
import estadocarjson from "@/assets/json/estadocarnet.json";
import diasjson from "@/assets/json/dias.json";
import firebase from "firebase/compat";

  export default {
    name: 'leftmenujuegos',
    components: {
      loginbox
    },
    props:{
      abreviado:{
        type: String
      }
    },
    data: () => ({
      drawer: null,
      teventos: localStorage.eventos,
      paises:[],
      ttnegocios:false,
      tpromotor:false,
      tsocio:false,
      browser:false,
      tsuperadmin: false,
      tokencaptcha:''
  }),
  mounted(){
    this.armamenu();
    this.ttnegocios = this.$store.state.tnegocios
    this.overlayLogin = true
    this.getPaises();
    this.fnBrowserDetect();
    if(this.usuario.id === undefined){
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.tpromotor = this.usuario.promotor
              this.tsocio = this.usuario.socio
              this.tsuperadmin = this.usuario.superAdmin

              this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.recaptcha(user)
              this.overlayLogin = false
            }else{
              this.overlayLogin = false
            }
          })
    }else{
      this.tpromotor = this.usuario.promotor
      this.tsocio = this.usuario.socio
      this.tsuperadmin = this.usuario.superAdmin

      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.desconectado = false
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      this.negociospromotor = this.pnegocios
      store.dispatch("conectarse")
      this.overlayLogin = false

    }
  },
  methods: {
    armamenu(){
    this.teventos = this.cliente.eventos;
    localStorage.eventos = this.cliente.eventos;
    },
    getPaises(){
      axios.get("paises/activos",{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response=>{
            this.paises = response.data
          })
    },
    fnBrowserDetect(){

      let userAgent = navigator.userAgent;

      if(userAgent.match(/chrome|chromium|crios/i)){
        this.rese = "chrome";
        this.browser = true;
      }else if(userAgent.match(/firefox|fxios/i)){
        this.rese = "firefox";
        this.browser = true;
      }  else if(userAgent.match(/safari/i)){
        this.rese = "safari";
        this.browser = true;
      }else if(userAgent.match(/opr\//i)){
        this.rese = "opera";
        this.browser = true;
      } else if(userAgent.match(/edg/i)){
        this.rese = "edge";
        this.browser = true;
      }else{
        this.rese="No browser detection";
        this.browser = false;
      }

    },
    async recaptcha(user) {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      this.tokencaptcha = await this.$recaptcha('login')
      // Do stuff with the received token.
      if(this.tokencaptcha !=='' ){
        this.logeo(user)
      }

    },
    logeo(user){
      var bodyFormData = new FormData();
      bodyFormData.append('uuid', user.uid);
      bodyFormData.append('token', this.tokencaptcha);


      this.overlayLogin = true
      axios.post("personas/loginbyuid",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            store.dispatch("fetchUsuario", response.data.persona);

            if(response.data.usuarionegocio!==null){
              store.dispatch("fetchNegocios", response.data.usuarionegocio);
              store.dispatch("connegocios")
              localStorage.negocios = true
              this.ttnegocios = true
            }else{
              store.dispatch("sinnegocios")
              this.ttnegocios = false
              localStorage.negocios = false
            }
            if(response.data.clientes!==null){
              store.dispatch("fetchClientes", response.data.clientes);
              store.dispatch("fetchCliente", response.data.clientes[0]);
              this.teventos = true
              localStorage.eventos = true

            }else{
              store.dispatch("fetchCliente", response.data.usuarionegocio.negocio[0].cliente);
              this.teventos = false
              localStorage.eventos = false
            }
            this.tsuperadmin = response.data.persona.superAdmin

            store.dispatch("fetchTipoEntradas", tipoentrjson);
            store.dispatch("fetchTipoPagos", tipopagjson);
            store.dispatch("fetchTipoEventos", tipoevenjson);
            store.dispatch("fetchTipoMembresias", tipomembrjson);
            store.dispatch("fetchSexos", sexosjson);
            store.dispatch("fetchEstadoCarnets", estadocarjson);
            store.dispatch("fetchDias", diasjson);
            store.dispatch("conectarse");
            this.desconectado = false;
            this.overlayLogin = false;
            this.dialog=false;
            this.tpromotor = response.data.persona.promotor
            this.abreviado =  response.data.persona.nombre + " " +  response.data.persona.apellidoPaterno;
          })
          .catch(error => {
            this.overlayLogin = false;
            console.log(error);
          });
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      cliente: "cliente"
    })
  }
  }
</script>